/**
 * WIZARD.UTILS
 * Regle commune aux wizards : une etape reste inaccessible tant qu'un champ obligatoire est vide.
 * Le message est centralise ici pour que tous les wizards parlent de la meme facon.
 */

export function getWizardStepLockReason(requiredLabel: string, stepLabel: string) {
  return `Vous devez renseigner ${requiredLabel} avant de passer à l'étape « ${stepLabel} ».`
}
